import api from '@/api/axios';
import type { AxiosResponse } from 'axios';

export type MarketingChannelType = {
  displayName: string;
  value: string;
  order: number;
};

export const fetchMarketingChannels = async (): Promise<
  MarketingChannelType[]
> => {
  try {
    const { data }: AxiosResponse<MarketingChannelType[]> = await api.get(
      '/api/marketingchannels',
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
